<template>
  <modal
    class="modal"
    name="set-user-type-modal"
    transition="pop-out"
    :width="modalWidth"
    :height="320"
    :adaptive="true"
    :clickToClose="false"
  >
  <div class="flex flex-column items-center justify-center w-100 h-100">


      <div class="h2 heigthMobile">
            <clip-loader :loading="isLoadingLink" :color="color" :size="size"></clip-loader>
      </div>

      <span class="mb-4 flex items-center flex-wrap justify-center dn f3">{{ $t("users.choseUserType") }}</span>

      <div class="w-100 flex flex-column items-center background-color custom-margin-top">

        <div class="w-50-ns w-50">
          <div class="flex justify-center items-center">
            <div class="text-center">
              <img
                src="https://beathey.com/uploads/banners/04-04.jpg"
                alt="Fan"
                class="dim"
                @click="setUserType(0)"
              />
              <span class="mt2 flex items-center flex-wrap justify-center dn ttu f5">{{ $t("users.userType.musicFan") }}</span>
            </div>

            <div class="w-30"></div>

            <div class="text-center">
              <img
                src="https://beathey.com/uploads/banners/00-02.jpg"
                alt="Artista"
                class="dim"
                @click="setUserType(1)"
              />
              <span class="mt2 flex items-center flex-wrap justify-center dn ttu f5">{{ $t("users.userType.producer") }}</span>
            </div>
          </div>
        </div>

      </div>

      <div class="mt3 mb3">
          <span class="mb-4 flex items-center flex-wrap justify-center f5">{{ $t("users.textUserType") }}</span>
      </div>

  </div>

  </modal>
</template>

<script>
  import {mapActions} from 'vuex'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  const MODAL_WIDTH = 600

  export default {
    name: 'set-user-type-modal',
    components: {
      ClipLoader
    },
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        color: '#808080',
        size: '30px'
      }
    },
    computed: {
      isLoadingLink () {
        return this.$loading.isLoading('user editUserType')
      }
    },
    methods: {
      ...mapActions('user', [
        'editUserType'
      ]),
      setUserType (type) {
        this.$modal.hide('set-user-type-modal')
        if (parseInt(type) === 1) {
          this.$modal.show('set-name-artist-modal')
        } else {
          this.editUserType({userType: type}).catch(e => {
            this.$toasted.show(e.message, {type: 'error'})
          })
          location.reload()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .modal {
    z-index: 10000;
  }

.custom-margin-top {
  margin-top: 1rem;
}

@media (min-width:300px) and (max-width:600px) {
  .heigthMobile{
    height: 0px !important;
  }

  .negrita {
      font-weight: bold !important;
      font-family: 'Titillium Web' !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/SetUserTypeModal.vue